import React from "react"

export const XopowoOptions  = props => {
  return (
    <div className="actions-btn">
      <div className="beatContainer pointerHover" id="beatContainer" data-id="playBeat-btn" title="F">
        <img draggable="false" src={props.imgSrc[21]} className="playBeat hidden noContextMenu" alt="Play Beat On" onClick={props.handleClick} />
        <img draggable="false" src={props.imgSrc[20]} className="playBeat visible noContextMenu" alt="Play Beat Off" onClick={props.handleClick} />
      </div>
      <div className="loopContainer pointerHover" id="loopContainer" data-id="playLoop-btn" title="V">
        <img draggable="false" src={props.imgSrc[1]} className="playloop hidden noContextMenu" alt="Play Loop On" onClick={props.handleClick} />
        <img draggable="false" src={props.imgSrc[0]} className="playloop visible noContextMenu" alt="Play Loop Off" onClick={props.handleClick} />
      </div>
      <div className="refreshContainer pointerHover" id="refreshContainer" data-id="refresh-btn" title="B">
        <img draggable="false" src={props.imgSrc[6]} className="reset hidden noContextMenu" alt="Reset On" onClick={props.handleClick} />
        <img draggable="false" src={props.imgSrc[5]} className="reset visible noContextMenu" alt="Reset Off" onClick={props.handleClick} />
      </div>
      <div className="ownershipContainer pointerHover" id="ownershipContainer" data-id="ownership-btn" title="N">
        <div data-href={props.path} className="ownership" id="ownershipLink" data-id="ownership-btn">
          <img draggable="false" src={props.imgSrc[4]} className="ownership hidden noContextMenu" alt="Ownership On" onClick={props.handleClick} />
          <img draggable="false" src={props.imgSrc[3]} className="ownership visible noContextMenu" alt="Ownership Off" onClick={props.handleClick} />
        </div>
      </div>

    </div>
  )
}